import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { ShieldCheck, CheckCircle } from "lucide-react";

const GuaranteeSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const guaranteePoints = [
    "Commencez maintenant et plongez dans le Module 1",
    "Expérimentez, intégrez et cheminez à votre rythme",
    "Remboursement sous 14 jours si non satisfait",
    "Limite d'ouverture du module 1",
  ];

  return (
    <section
      ref={ref}
      data-testid="guarantee-section"
      className="relative py-24 lg:py-32 overflow-hidden"
      style={{ background: "#030014" }}
    >
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-amber-500/20 to-amber-600/20 border border-amber-500/30 mb-8"
          >
            <ShieldCheck className="w-5 h-5 text-amber-400" />
            <span className="text-amber-400 font-semibold uppercase tracking-wider text-sm">
              Garantie Satisfaction
            </span>
          </motion.div>

          {/* Title */}
          <h2
            className="text-4xl sm:text-5xl font-light text-white mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            La Garantie{" "}
            <span className="text-gradient-gold">Better Bigger Faster</span>
          </h2>

          {/* Description */}
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed">
            Nous sommes convaincus que Quantic Revolution 4.0 transformera votre pratique. 
            C'est pourquoi nous offrons une garantie de satisfaction.
          </p>

          {/* Guarantee Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="glass-card p-8 rounded-2xl border-amber-500/20 max-w-2xl mx-auto"
          >
            <div className="space-y-4">
              {guaranteePoints.map((point, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.4, delay: 0.5 + index * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <CheckCircle className="w-5 h-5 text-amber-400 flex-shrink-0" />
                  <span className="text-slate-300">{point}</span>
                </motion.div>
              ))}
            </div>

            <div className="mt-8 pt-6 border-t border-slate-700/50">
              <p className="text-slate-400 italic">
                "N'hésitez plus, il n'y a pas d'enjeu et cette formation vous apportera 
                bien plus que vous ne l'imaginez."
              </p>
              <p className="text-cyan-400 mt-2 font-medium">— Gilles Delieuze</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
